<template>
    <el-affix>
        <el-page-header :icon="returnIcon" @back="clickReturnBtn" class="my-normal-header-box">
            <template #title>
                <span class="text-large font-600 mr-3"> {{returnLabel}} </span>
            </template>

            <template #content>
                <LangSelect
                    :confirmFlag="false"
                />
            </template>

            <template #extra>
                <!--                    <el-badge :value="200" :max="99" style="margin-right: 15px">-->
                <el-button circle @click="clickChatBtn" v-if="useChatBtn == true" >
                    <font-awesome-icon icon="fa-solid fa-comments" />
                </el-button>
                <!--                    </el-badge>-->
            </template>
        </el-page-header>

        <el-divider class="my-normal-divider" />
    </el-affix>
</template>

<script setup>
//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faComments } from '@fortawesome/free-solid-svg-icons'
import {ArrowLeft} from "@element-plus/icons-vue";
import {computed} from "vue";
import LangSelect from "@/components/shopopee/common/langSelect.vue";

library.add(faComments)

const props = defineProps((["returnLabel", "useChatBtn", "useReturnBtn"]))
const emits = defineEmits(["clickChatBtn", "clickReturnBtn"])

const returnIcon = computed(() => {
    let icon = null

    if (props.useReturnBtn === true){
        icon = ArrowLeft
    }

    return icon
})

function clickChatBtn(){
    emits("clickChatBtn")
}

function clickReturnBtn(){
    emits("clickReturnBtn")
}


</script>

<style scoped>
    .my-normal-header-box {
        padding: 15px;
        background: #fefefe
    }

    .my-normal-divider {
        margin-bottom: 10px;
        margin-top: 0;
    }
</style>